import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultRedirectsPage from './Pages/DefaultRedirectsPage';
import WizardPage from './Pages/WizardPage';

const RedirectsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:redirectId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultRedirectsPage />
            </Route>
        </Switch>
    );
};

export default RedirectsRouter;
